/* NOTE!!!!!!
 * must specify in camelCase if in darkly ui you specify
 * 'client-display-premium-info' here it should be set as 'clientDisplayPremiumInfo'
 */

import { LaunchDarklyStringFeatureFlags } from 'integrations/launchDarkly/legacy/stringFlags/types';

export enum LaunchDarklyFeatureFlagKeys {
  reportingViewClassificationByLocationQuery = 'reportingViewClassificationByLocationQuery',
  taskListWorkerName = 'taskListWorkerName',
  workerProfileGlobalId = 'workerProfileGlobalId',
  analyticsDashboards = 'analyticsDashboards',
  enterpriseProjects = 'enterpriseProjects',
  enterpriseProjectTasks = 'enterpriseProjectTasks',
  openJobPostings = 'openJobPostings',
  logDocyardValidationInfo = 'logDocyardValidationInfo',
  roleBasedAccessForAnalytics = 'roleBasedAccessForAnalytics',
  rescindApprovedCandidates = 'rescindApprovedCandidates',
  extendJobFamilyGroup = 'extendJobFamilyGroup',
  continueFailedJobApplication = 'continueFailedJobApplication',
  sideLoadWorkdayData = 'sideLoadWorkdayData',
  countsInOrgNavForManagerlessOrgs = 'countsInOrgNavForManagerlessOrgs',
  dynamicAnalyticsConfig = 'dynamicAnalyticsConfig',
  customManagingSourceIcons = 'customManagingSourceIcons',
  workRequestAssociatedOutcomes = 'workRequestAssociatedOutcomes',
  removeCandidateApproveRejectButton = 'removeCandidateApproveRejectButton',
  disableTutorials = 'disableTutorials',
  jobApplicationToEngagementLink = 'jobApplicationToEngagementLink',
  supportWidget = 'supportWidget',
  financeJournalConfig = 'financeJournalConfig',
  defaultActiveUsers = 'defaultActiveUsers',
  timeAndExpenseAuditReports = 'timeAndExpenseAuditReports',
  mazeSnippet = 'mazeSnippet',
  newRecipeEditor = 'newRecipeEditor',
  dataConnectorExtracts = 'dataConnectorExtracts',
  timesheetSourceTimeAllocations = 'timesheetSourceTimeAllocations',
  workerRetroactiveChanges = 'workerRetroactiveChanges',
  taeHubsApprovedDateFilter = 'taeHubsApprovedDateFilter',
  teamsNotification = 'teamsNotification',
  workdayConfiguration = 'workdayConfiguration',
  timesheetSettingsBusinessSite = 'timesheetSettingsBusinessSite',
  devTools = 'devTools',
  taeHubsDateWindow = 'taeHubsDateWindow',
  taeInvoiceHubImprovements = 'taeInvoiceHubImprovements',
  complianceCertificationManagement = 'complianceCertificationManagement',
  currencyFieldInExpenseCategory = 'currencyFieldInExpenseCategory',
  inAppDocumentationDrawer = 'inAppDocumentationDrawer',
  trackUnusedGqlFields = 'trackUnusedGqlFields',
  timesheetImportCostCenterFromEngagement = 'timesheetImportCostCenterFromEngagement',
  imageResizer = 'imageResizer',
  complianceAndRisksWidget = 'complianceAndRisksWidget',
  clientSupportLinks = 'clientSupportLinks',
  engagementSpend = 'engagementSpend',
  autoDisableInactiveUsers = 'autoDisableInactiveUsers',
  requireExistenceDetectionFieldsAreUnique = 'requireExistenceDetectionFieldsAreUnique',
  nationalIdLegacySuppressionBehaviour = 'nationalIdLegacySuppressionBehaviour',
  customizeStandardReport = 'customizeStandardReport',
  calculateWorkPostingBudget = 'calculateWorkPostingBudget',
  hideNotImplementedRateFrequencies = 'hideNotImplementedRateFrequencies',
  importerEngagementRetroChangesValidation = 'importerEngagementRetroChangesValidation',
  requirednessOnFinancialFieldLevel = 'requirednessOnFinancialFieldLevel',
  readonlySmartformTasks = 'readonlySmartformTasks',
  autoResizeAnalyticsDashboard = 'autoResizeAnalyticsDashboard',
  externalIntegrations = 'externalIntegrations',
  languageSwitcher = 'languageSwitcher',
  supplierPaymentTerms = 'supplierPaymentTerms',
  contractSpend = 'contractSpend',
  uiRestrictCurrencies = 'uiRestrictCurrencies',
  uiOrgPickerV2 = 'uiOrgPickerV2',
  uiNewInvoiceSettingsPage = 'uiNewInvoiceSettingsPage',
  importerOpenChangeSetValidation = 'importerOpenChangeSetValidation',
  redirectHomeInactiveSmartForms = 'redirectHomeInactiveSmartForms',
  duplicateSearch = 'duplicateSearch',
  showJobProfileCreationOption = 'showJobProfileCreationOption',
  downloadWorkdaySnapshot = 'downloadWorkdaySnapshot',
  dailyBriefing = 'dailyBriefing'
}

export enum LaunchDarklyNumberFeatureFlagKeys {
  mixpanelSessionRecording = 'mixpanelSessionRecording'
}

type LaunchDarklyBooleanFeatureFlags = PartialRecord<keyof typeof LaunchDarklyFeatureFlagKeys, boolean | undefined>;
type LaunchDarklyNumberFeatureFlags = PartialRecord<keyof typeof LaunchDarklyNumberFeatureFlagKeys, number | undefined>;

/**
 * @deprecated use `OcDarklyFlags` from 'oc-web/packages/enterprise/src/integrations/launchDarkly/__generated__/darkly.flags.ts' instead
 */
export type LaunchDarklyFeatureFlags = LaunchDarklyBooleanFeatureFlags &
  LaunchDarklyStringFeatureFlags &
  LaunchDarklyNumberFeatureFlags;
